import React, { useState } from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import { IconButton, TableHead, TextField, Tooltip } from "@mui/material";
import { DeleteRounded, Search } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import moment from "moment";
import EditReviewForm from "layouts/products/ProductDetails/editReviewForm";
import { productUpdateReviewApi } from "store/api";
import Success from "components/Success";

function EnhancedTableToolbar (props) {
  const { numSelected, handleChange } = props;

  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: theme =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: "1 1 100%" }} color='inherit' variant='subtitle1' component='div'>
          {numSelected} selected
        </Typography>
      ) : (
        <Typography sx={{ flex: "1 1 100%" }} variant='h6' id='tableTitle' component='div'>
          Users List
        </Typography>
      )}
      <TextField
        placeholder='Search here...'
        InputProps={{
          endAdornment: (
            <IconButton color='inherit'>
              <Search />
            </IconButton>
          ),
        }}
        color='success'
        onChange={handleChange}
        style={{ backgroundColor: "", borderRadius: "4px" }}
      />
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const ReviewList = ({ users, active, FetchUsers }) => {
  const navigate = useNavigate();
  const redirect = data => {
    navigate("/user-details", { state: { userId: data.userId } });
  };
  const showData = users.filter(e =>
    active == 0
      ? e
      : active == 1
      ? e.accountStatus == "active"
      : active == 2
      ? e.accountStatus == "pending"
      : active == 3
      ? e.accountStatus == "restricted"
      : e.accountStatus == "picked-up"
  );
  const [updateReviewData, setUpdateReviewData] = useState({});
  const [reviewOpen, setReviewOpen] = useState(false);
  const [msg, setMsg] = React.useState("");
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const handleChangeUpdateReview = e => {
    const { value, name } = e.target;
    setUpdateReviewData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  const handleClickOpenReview = data => {
    setUpdateReviewData(data);
    setReviewOpen(true);
  };

  const handleCloseReview = () => {
    setReviewOpen(false);
    setUpdateReviewData("");
  };

  const handleSubmitReview = async e => {
    e?.preventDefault();
    const response = await productUpdateReviewApi(updateReviewData);
    if (response?.success) {
      setMsg("Review update successfully");
      setOpenSuccess(true);
      setSuccess(true);
      FetchUsers();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenLoader(false);
  };

  const deleteReview = async data => {
    let apiData = {
      isDelete: true,
      productReviewId: data?.productReviewId,
    };
    const response = await productUpdateReviewApi(apiData);
    if (response?.success) {
      setMsg("Review Delete successfully");
      setOpenSuccess(true);
      setSuccess(true);
      FetchUsers()
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleChangePublishReview = async (e, review) => {
    // setOpenLoader(true);
    const { value } = e?.target;
    let data = {
      isActive: value == "false" ? false : true,
      productReviewId: review.productReviewId,
    };
    const response = await productUpdateReviewApi(data);
    if (response?.success) {
      setMsg("Review update successfully");
      setOpenSuccess(true);
      setSuccess(true);
      FetchUsers()
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label='customized table'>
        <TableBody>
          <TableRow>
            <StyledTableCell style={{ fontWeight: "500" }}>Name</StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='center'>
              Review
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='center'>
              Rating
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='center'>
              Date
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='center'>
              Publish
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='center'>
              Action
            </StyledTableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          {showData?.length == 0 && (
            <TableRow>
              <TableCell>No Review found</TableCell>
            </TableRow>
          )}
          {showData.map(row => (
            <StyledTableRow key={row.userId}>
              <StyledTableCell component='th' scope='row'>
                <span style={{ whiteSpace: "nowrap" }}>{row.name}</span>
              </StyledTableCell>
              <StyledTableCell align='center'>{row.review ? row.review : "---"}</StyledTableCell>
              <StyledTableCell align='center'>{row.rating ? row.rating : "---"}</StyledTableCell>
              <StyledTableCell align='center'>{moment(row.createdAt).format("ll")}</StyledTableCell>
              <StyledTableCell align='center'>
                <Tooltip title={"Status"}>
                  <PublishSwitch
                    onChange={event =>
                      handleChangePublishReview(event, {
                        productReviewId: row?.productReviewId,
                      })
                    }
                    value={!row?.isActive}
                    inputProps={{ "aria-label": "controlled" }}
                    checked={row?.isActive}
                  />
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell align='center'>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Tooltip
                    title='Edit'
                    style={{ cursor: "pointer" }}
                    onClick={() => handleClickOpenReview(row)}
                  >
                    <BorderColorRoundedIcon />
                  </Tooltip>
                  <Tooltip title='Delete' style={{ cursor: "pointer" }}>
                    <DeleteRounded onClick={() => deleteReview(row)} />
                  </Tooltip>
                </span>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
      <EditReviewForm
        open={reviewOpen}
        handleClose={handleCloseReview}
        handleSubmit={handleSubmitReview}
        updateReviewData={updateReviewData}
        handleChangeUpdateReview={handleChangeUpdateReview}
      />
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </TableContainer>
  );
};

export default ReviewList;

const PublishSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    height: 18,
    width: 38,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 18,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 9,
      marginTop: -1,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
      marginTop: -1,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
  },
}));